import React from "react";
import { Box } from "@mui/material";

export default function DrawerResizeHandle({ onMouseDown }) {
  return (
    <Box
      onMouseDown={onMouseDown}
      role="separator"
      aria-label="Resize drawer"
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: 12,
        height: "100%",
        cursor: "col-resize",
        zIndex: 3,
        touchAction: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": { bgcolor: "action.hover" },
        "&:hover .resize-grip, &:active .resize-grip": { opacity: 1 }
      }}
    >
      <Box
        className="resize-grip"
        sx={{
          width: 3,
          height: 40,
          borderRadius: 2,
          bgcolor: "text.disabled",
          opacity: 0.35,
          transition: "opacity 120ms ease",
          pointerEvents: "none"
        }}
      />
    </Box>
  );
}
